import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const rootPaths = [
  '/',
  '/reliable-and-ready',
  '/financials',
  '/leadership',
  '/about'
];

const routes = [
  {
    path: rootPaths[0],
    name: 'Annual Report Home',
    component: Home
  },
  {
    path: rootPaths[1],
    name: 'Reliable and Ready',
    component: () => import('../views/ReliableAndReady.vue'),
    subRoutes: [
      {
        name: 'Striving to Exceed',
        path: `${rootPaths[1]}#striving`
      },
      {
        name: 'Providing for You',
        path: `${rootPaths[1]}#providing`
      },
      {
        name: 'Educating and Informing',
        path: `${rootPaths[1]}#educating`
      }
    ]
  },
  {
    path: rootPaths[2],
    name: 'Financials',
    component: () => import('../views/Financials.vue'),
    subRoutes: [
      {
        name: 'Highlights',
        path: `${rootPaths[2]}#highlights`
      },
      {
        name: 'Balance Sheets',
        path: `${rootPaths[2]}#balance-sheets`
      },
      {
        name: 'Statements of Income',
        path: `${rootPaths[2]}#statements-of-income`
      },
      {
        name: 'MVP Allocations',
        path: `${rootPaths[2]}#mvp-allocations`
      },
      {
        name: 'Policyholders\' Surplus',
        path: `${rootPaths[2]}#policyholders-surplus`
      },
      {
        name: 'Cumulative Dividends',
        path: `${rootPaths[2]}#cumulative-dividends`
      },
      {
        name: 'Premiums Per Physician',
        path: `${rootPaths[2]}#premiums-per-physician`
      }
    ]
  },
  {
    path: rootPaths[3],
    name: 'Leadership',
    component: () => import('../views/Leadership.vue'),
    subRoutes: [
      {
        name: 'Board of Directors',
        path: `${rootPaths[3]}#board-of-directors`
      },
      {
        name: 'Officers',
        path: `${rootPaths[3]}#officers`
      },
      {
        name: 'Committees',
        path: `${rootPaths[3]}#committees`
      }
    ]
  },
  {
    path: rootPaths[4],
    name: 'About SVMIC',
    component: () => import('../views/About.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
});

export default router;
